import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponse } from '../models/api-response';
import { Observable } from 'rxjs';
import { NotificationService } from '@optsolservices/ngx-notification';
import { HelperService } from './helper.service';
import * as fileSaver from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class BaseService {

  constructor(
    private http: HttpClient,
    private notificationService: NotificationService,
    private helperService: HelperService
  ) { }
  executeCommand<T>(command: string, body: any): Observable<ApiResponse<T>> {
    return this.http.post<ApiResponse<T>>(`${environment.apiUrl}/${environment.apiVersion}/generic/command/${command}`, body);
  }

  executePublicCommand<T>(command: string, body: any): Observable<ApiResponse<T>> {
    return this.http.post<ApiResponse<T>>(`${environment.apiUrl}/${environment.apiVersion}/generic/public/${command}`, body);
  }

  downloadResource(apiResourceKey: string, fileName: string, mimeType: string) {
    if (!apiResourceKey) {
      this.notificationService.error(`apiResourceKey not provided.`);
      return;
    }

    if (!fileName) {
      this.notificationService.error(`fileName not provided.`);
      return;
    }

    if (!mimeType) {
      this.notificationService.error(`mimeType not provided.`);
      return;
    }


    this.http.get(this.helperService.resourcePrivateUrl(apiResourceKey),
      {
        responseType: 'blob'
      }).subscribe(response => {
        const blob = new Blob([response], { type: mimeType });
        fileSaver.saveAs(blob, fileName);
      });
  }

  generateReport(data: {reportConfig: {reportDefinitionMd5Hash: string, filename: string, fileExtension: string, mimeType: string}, reportParameters: any} ) {
    if (!data.reportConfig.reportDefinitionMd5Hash) {
      this.notificationService.error(`reportDefinitionMd5Hash not provided.`);
      return;
    }

    this.http.post(
      `${this.helperService.apiDownloadUrl()}${data.reportConfig.reportDefinitionMd5Hash}`,
      data ?? {},
      {
        responseType: 'blob'
      }).subscribe(response => {
        const blob = new Blob([response], { type: data.reportConfig.mimeType });
        fileSaver.saveAs(blob, `${data.reportConfig.filename}.${data.reportConfig.fileExtension}`);
      });
  }
}
